// AgreementCheckboxes.jsx - Taahhütname onay kutuları
import React, { useState } from 'react';

const AgreementCheckboxes = ({
  capacityAgreed,
  receiptAgreed,
  cancelPolicyAgreed,
  onCapacityAgree,
  onReceiptAgree,
  onCancelPolicyAgree
}) => {
  const [expandedAgreement, setExpandedAgreement] = useState(null);

  const agreements = {
    capacity: {
      title: 'Kapasite Kuralları',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
      content: `
Rezervasyon sırasında belirtilen kişi sayısını aşmamayı kabul ediyorum.

Maksimum kapasite 8 kişidir. Kapasite aşımı tespit edilmesi durumunda:
• 1. İhlal: Uyarı
• 2. İhlal: 1 hafta rezervasyon yasağı
• 3. İhlal: Sistemden kalıcı çıkarılma

Bu kuralları okudum ve kabul ediyorum.
      `.trim()
    },
    receipt: {
      title: 'Dekont Yükleme Taahhütnamesi',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
      ),
      content: `
Dekont Yükleme Taahhütnamesi:

✓ Havale işlemini yaptığımı ve dekontun gerçek olduğunu beyan ediyorum.

✓ Geçersiz/sahte dekont yüklemem durumunda aşağıdaki yaptırımları kabul ediyorum:
  - 1. İhlal: 2 hafta rezervasyon yasağı
  - 2. İhlal: 1 ay rezervasyon yasağı  
  - 3. İhlal: Sistemden kalıcı çıkarılma

✓ Dekontun onaylanmaması durumunda rezervasyonumun iptal edilebileceğini biliyorum.

✓ İptal edilen rezervasyonlar için iade yapılmayacağını kabul ediyorum.

Bu şartları okudum ve kabul ediyorum.
      `.trim()
    },
    cancelPolicy: {
      title: 'İptal Politikası',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      ),
      content: `
İptal Politikası:

• Rezervasyonları iptal edebilirsiniz
• İptal son süresi: Rezervasyondan 2 saat öncesi
• İptal edilen rezervasyonlar için para iadesi YAPILMAZ
• Geç iptal durumunda rezervasyon ücreti tahsil edilir

Bu politikayı okudum ve kabul ediyorum.
      `.trim()
    }
  };

  const toggleAgreement = (key) => {
    setExpandedAgreement(expandedAgreement === key ? null : key);
  };

  return (
    <div className="space-y-4">
      <h3 className="text-xl font-semibold text-blue-100 flex items-center">
        <svg className="w-6 h-6 mr-2 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Taahhütnameler
      </h3>

      <p className="text-sm text-gray-300">
        Rezervasyonu tamamlamak için aşağıdaki taahhütnameleri okumalı ve kabul etmelisiniz.
      </p>

      {/* Kapasite */}
      <div className={`
        border rounded-lg transition-all duration-200
        ${capacityAgreed ? 'border-green-500 bg-green-900/10' : 'border-gray-700 bg-gray-800/50'}
      `}>
        <div className="p-4">
          <div className="flex items-start">
            <input
              type="checkbox"
              id="capacityAgreement"
              checked={capacityAgreed}
              onChange={(e) => onCapacityAgree(e.target.checked)}
              className="mt-1 w-4 h-4 text-blue-600 bg-gray-700 border-gray-600 rounded focus:ring-blue-500"
            />
            <label htmlFor="capacityAgreement" className="ml-3 flex-1 cursor-pointer">
              <div className="flex items-center justify-between">
                <div className="flex items-center text-blue-200 font-semibold">
                  {agreements.capacity.icon}
                  <span className="ml-2">{agreements.capacity.title}</span>
                </div>
                <button
                  type="button"
                  onClick={() => toggleAgreement('capacity')}
                  className="text-blue-400 text-sm hover:text-blue-300"
                >
                  {expandedAgreement === 'capacity' ? 'Gizle' : 'Oku'}
                </button>
              </div>
            </label>
          </div>

          {expandedAgreement === 'capacity' && (
            <div className="mt-3 ml-7 p-3 bg-gray-900/50 rounded text-sm text-white whitespace-pre-line border border-gray-700">
              {agreements.capacity.content}
            </div>
          )}
        </div>
      </div>

      {/* Dekont */}
      <div className={`
        border rounded-lg transition-all duration-200
        ${receiptAgreed ? 'border-green-500 bg-green-900/10' : 'border-gray-700 bg-gray-800/50'}
      `}>
        <div className="p-4">
          <div className="flex items-start">
            <input
              type="checkbox"
              id="receiptAgreement"
              checked={receiptAgreed}
              onChange={(e) => onReceiptAgree(e.target.checked)}
              className="mt-1 w-4 h-4 text-blue-600 bg-gray-700 border-gray-600 rounded focus:ring-blue-500"
            />
            <label htmlFor="receiptAgreement" className="ml-3 flex-1 cursor-pointer">
              <div className="flex items-center justify-between">
                <div className="flex items-center text-blue-200 font-semibold">
                  {agreements.receipt.icon}
                  <span className="ml-2">{agreements.receipt.title}</span>
                </div>
                <button
                  type="button"
                  onClick={() => toggleAgreement('receipt')}
                  className="text-blue-400 text-sm hover:text-blue-300"
                >
                  {expandedAgreement === 'receipt' ? 'Gizle' : 'Oku'}
                </button>
              </div>
            </label>
          </div>

          {expandedAgreement === 'receipt' && (
            <div className="mt-3 ml-7 p-3 bg-gray-900/50 rounded text-sm text-white whitespace-pre-line border border-gray-700">
              {agreements.receipt.content}
            </div>
          )}
        </div>
      </div>

      {/* İptal Politikası */}
      <div className={`
        border rounded-lg transition-all duration-200
        ${cancelPolicyAgreed ? 'border-green-500 bg-green-900/10' : 'border-gray-700 bg-gray-800/50'}
      `}>
        <div className="p-4">
          <div className="flex items-start">
            <input
              type="checkbox"
              id="cancelPolicyAgreement"
              checked={cancelPolicyAgreed}
              onChange={(e) => onCancelPolicyAgree(e.target.checked)}
              className="mt-1 w-4 h-4 text-blue-600 bg-gray-700 border-gray-600 rounded focus:ring-blue-500"
            />
            <label htmlFor="cancelPolicyAgreement" className="ml-3 flex-1 cursor-pointer">
              <div className="flex items-center justify-between">
                <div className="flex items-center text-blue-200 font-semibold">
                  {agreements.cancelPolicy.icon}
                  <span className="ml-2">{agreements.cancelPolicy.title}</span>
                </div>
                <button
                  type="button"
                  onClick={() => toggleAgreement('cancelPolicy')}
                  className="text-blue-400 text-sm hover:text-blue-300"
                >
                  {expandedAgreement === 'cancelPolicy' ? 'Gizle' : 'Oku'}
                </button>
              </div>
            </label>
          </div>

          {expandedAgreement === 'cancelPolicy' && (
            <div className="mt-3 ml-7 p-3 bg-gray-900/50 rounded text-sm text-white whitespace-pre-line border border-gray-700">
              {agreements.cancelPolicy.content}
            </div>
          )}
        </div>
      </div>

      {/* Toplam Durum */}
      {capacityAgreed && receiptAgreed && cancelPolicyAgreed && (
        <div className="p-3 bg-green-900/20 border border-green-700/50 rounded-lg flex items-center">
          <svg className="w-5 h-5 text-green-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-sm text-green-200">Tüm taahhütnameler kabul edildi</span>
        </div>
      )}
    </div>
  );
};

export default AgreementCheckboxes;
